import React, { Children } from "react";
//@ts-ignore
import AtomTable from "../../Atomic/organism/AtomTable";
interface Props {
  closeModal: () => void;
  title: string;
  children?: React.ReactNode;
}
export default function Modal({ title, closeModal, children }: Props) {
  return (
    <>
      <div className="common-modal on">
        <div
          className="modal-inner"
          style={{
            padding: "16rem 5rem",
          }}
        >
          <div className="modal-page">
            <div className="page-header">
              <div className="page-title">
                <span>{title}</span>
              </div>
              <button
                onClick={() => closeModal()}
                type="button"
                className="modal-close"
              >
                <i className="ri-close-fill icon"></i>
              </button>
            </div>
            <div className="page-body">
              <div className="flex-container">
                <div className="common-table-wrapper">{children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
